<template>
    <div id="step_component_wrapper">
        <div class="slot-content">
            <v-select label="ragioneSociale" :options="clienti" v-model="selected" ref="select"
            :placeholder="$Jed.firstUpperTranslate('select a %1$s from the list below', null, {key: 'customer'}, 'male')"
            :selectStyle="{'background-color': 'white', 'border-radius': '4px'}"
            :tagStyle="{'background-color': '#5897fb', color: 'white', padding: '3px'}"
            :menuStyle="{position: 'relative', 'max-height': '150px'}"
            :activeStyle="{'background-color': '#5897fb', color: 'white'}"
            :highStyle="{'background-color': '#ccc', color: 'white'}">
            </v-select>
        </div>
        <div class="slot-button">
            <button v-if="!backTo1Allowed" class="btn btn-danger" @click="$root.logout()">{{$Jed.firstUpperTranslate('logout', null)}}</button>
            <button v-else class="btn btn-danger" @click="$emit('backward')">{{$Jed.firstUpperTranslate('back', null)}}</button>

            <button class="btn btn-primary-default" @click="forward" :disabled="selected == null">{{$Jed.firstUpperTranslate('confirm', null)}}</button>
        </div>
    </div>
</template>
<script>

import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"
import { eventBus } from "../../../eventbus";
    export default {
        mounted: function(){
            this.getListaClienti();
            //this.$refs.select.open = true //se parte aperto non posso fare la ricerca nel dropdown
        },
        components: {
            vSelect
        },
        props: {
            backTo1Allowed: {
               type: Boolean,
               default: false
            }
        },
        data: function(){
            return {
                clienti: [],
                selected: null
            }
        },
        methods: {
            forward: function(){
                var parameters = {};

                parameters.functionName = "load_first_or_parameter";
                
                //se ci sono dei pending changes della sync
                //(non dovrebbero esserci perchè la sync viene fatta subito 
                //ma potrebbe capitare se uno fa una modifica prima che una modifica precedente venga risolta (visto che la FrontEndSync è asincrona))
                var areTherePendingChanges = this.$root.dbRegistry.serializeChanges()
                areTherePendingChanges = JSON.parse(areTherePendingChanges)
                if(areTherePendingChanges && areTherePendingChanges.length > 0){
                    console.log("Pending changes detected: ", areTherePendingChanges)
                    eventBus.$emit('alert', {
                        message: this.$Jed.firstUpperTranslate("we're completing data synchronization of the previous client. Wait a few seconds before choosing another client"), 
                        type: "info",
                        action: ''
                    })
                } else {
                    console.log("No pending changes detected")
                    try {
                        parameters.override = { idCliente: this.selected.idCliente, ragioneSociale: this.selected.ragioneSociale}
                        this.$emit('forward', parameters);
                    } catch(err) {
                        console.log("error in emitting forward from SELEZIONE CLIENTE");
                        console.log(err)
                    }
                }                
            },
            getListaClienti: function(){
                this.clienti = [];
                if(navigator.onLine){
                    this.$root.microservice({
                        "role": "authentication",
                        "cmd": "GetAgentClients",
                        "params": {
                            "idAgente": this.$Configs.idAgente
                        }
                        }).then((response) => {
                            if(response.body){
                                var clienti = response.body;
                                var array = clienti.clientsArray;
                                for(var i=0; i<array.length; i++){
                                    var cliente = {
                                        idCliente: array[i].idCli,
                                        ragioneSociale: array[i].ragSocCli
                                    }
                                    this.clienti.push(cliente);
                                }
                                localStorage.setItem("listaClienti", JSON.stringify(this.clienti))
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            var msg = err && err.body && err.body.error ? err.body.error : ''
                            eventBus.$emit('alert', {
                                message: "Application caught an error <br> <h5>Details: " + "authentication.GetAgentClients - " + msg +'</h5>',
                                type: "error",
                                action: ''
                            })
                        })
                } else {
                    var stored = localStorage.getItem("listaClienti")
                    if(stored){
                        this.clienti = JSON.parse(stored)
                    }
                }
                
            }
        }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/loader/steps/SelezionaCliente.vue?101aca2e